<template lang="pug">

  text-input(name="first_name", :label="label")

</template>

<script>

import TextInput from './TextInput'

export default {
  name: 'user-input-first-name',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'First name',
    },
  },
}

</script>
